export default {
      id: "oc-copy-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-copy",
      toString: function () {
        return this.url;
      }
    }